import * as React from 'react'

function SvgCarIcon(props) {
  return (
    <svg
      width={40}
      height={40}
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      role="img"
      {...props}
    >
      <g transform="translate(8, 8)">
        <path
          d="M7.5 16a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3ZM18 14.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0Z"
          fill="#000"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M18.92 6.01C18.72 5.42 18.16 5 17.5 5h-11c-.66 0-1.21.42-1.42 1.01L3 12v8c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-1h12v1c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-8l-2.08-5.99ZM6.85 7h10.29l1.08 3.11H5.77L6.85 7ZM19 17H5v-5h14v5Z"
          fill="#000"
        />
      </g>
    </svg>
  )
}

export default SvgCarIcon
